import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { signalSurfaces } from '@/theme/foundations/tokens';
import InitialsAvatar, { AvatarPerson } from './InitialsAvatar';

interface AvatarStackProps {
  people: AvatarPerson[];
  size?: number;
  /** Overlap in px. The design uses 7–8px. */
  overlap?: number;
  /** Ring color — should match the surface the stack sits on. */
  ring?: string;
  sx?: SxProps<Theme>;
}

/**
 * Overlapping collaborator avatars. The ring is the surface color rather than a
 * border color, so the circles appear to punch through each other.
 */
export const AvatarStack: React.FC<AvatarStackProps> = ({
  people,
  size = 22,
  overlap = 7,
  ring = signalSurfaces.avatarRing,
  sx,
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', ...sx }}>
    {people.map((person, i) => (
      <InitialsAvatar
        key={`${person.initials}-${i}`}
        {...person}
        size={size}
        ring={ring}
        sx={{ marginRight: i === people.length - 1 ? 0 : `-${overlap}px` }}
      />
    ))}
  </Box>
);

export default AvatarStack;
